// extracted by mini-css-extract-plugin
export var avatar = "_i5-3";
export var avatarContainer = "_i5-2";
export var avatarSpacer = "_i5-5";
export var avatarSpacerContainer = "_i5-4";
export var avatarStackContainer = "_i5-1";
export var bubble = "_i5-0";
export var remainderBubble = "_i5-6";